/* CheckBoxEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;

class CheckBoxEditor extends CommonEditor {
    constructor(options) {
        super(options);
    }

    _createInput() {
        return new InputCheckboxControl({
            darkTheme: true,
        });
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = CheckBoxEditor;
